module.exports = __webpack_public_path__ + "static/media/logo-prefeitura-PGM.4b09be58.svg";